import { render } from "./ControlloFattureFornitoriGAS.vue?vue&type=template&id=feb8c1b2"
import script from "./ControlloFattureFornitoriGAS.vue?vue&type=script&lang=js"
export * from "./ControlloFattureFornitoriGAS.vue?vue&type=script&lang=js"

import "./ControlloFattureFornitoriGAS.vue?vue&type=style&index=0&id=feb8c1b2&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__